import React, { FC } from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { TEXT_AREA_MARGIN_SPACING } from '../constants';
import { TestID } from './constants';

type Props = {
  isDisabled: boolean;
} & WithStyles;

const styles = (theme) =>
  createStyles({
    sendButton: {
      marginRight: TEXT_AREA_MARGIN_SPACING,
    },
  });

const ChatInputFormSubmitButton: FC<Props> = ({ classes, isDisabled }) => (
  <Button
    className={classes.sendButton}
    color="primary"
    data-testid={TestID}
    disabled={isDisabled}
    type="submit"
    variant="contained"
  >
    <Typography color="inherit" variant="body1">
      Send
    </Typography>
  </Button>
);

export default withStyles(styles)(ChatInputFormSubmitButton);
